import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const handleCloseMenu = () => {
    setIsOpen(false);
  };
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
 
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true); 
      } else {
        setIsScrolled(false); 
      }
    };
    window.addEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed w-full z-50 py-2 transition-colors duration-500 ease-in-out ${
        isScrolled ? "bg-black shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className={`text-gray-300 font-serif no-underline text-3xl font-bold ${isScrolled ? "text-white" : "text-white"}`}>
              Zenetix
            </Link>
          </div>
          <div className="sm:hidden">
            <button
              onClick={handleToggle}
              className="text-gray-300 hover:text-white focus:outline-none"
            >

              <svg
                className={`h-6 w-6 transform transition-transform duration-300 ${
                  isOpen ? "rotate-90" : "rotate-0"
                } ${isScrolled ? "white" : "text-white"}`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d={
                    isOpen
                      ? "M6 18L18 6M6 6l12 12"
                      : "M4 6h16M4 12h16M4 18h16"
                  }
                />
              </svg>
            </button>
          </div>

          <div className="hidden sm:flex space-x-4">
            <Link
              to="/"
              className={`text-gray-300 text-xl no-underline hover:bg-gray-900 hover:text-white px-3 py-2 rounded-md text-sm font-medium ${
                isScrolled ? "white" : "text-white"
              }`}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`text-gray-300 text-xl no-underline hover:bg-gray-900 hover:text-white px-3 py-2 rounded-md text-sm font-medium ${
                isScrolled ? "white" : "text-white"
              }`}
            >
              About
            </Link>
            <Link
              to="/services"
              className={`text-gray-300 text-xl no-underline hover:bg-gray-900 hover:text-white px-3 py-2 rounded-md text-sm font-medium ${
                isScrolled ? "white" : "text-white"
              }`}
            >
              Services
            </Link>
            <Link
              to="/contact"
              className={`text-gray-300 text-xl no-underline hover:bg-gray-900 hover:text-white px-3 py-2 rounded-md text-sm font-medium ${
                isScrolled ? "white" : "text-white"
              }`}
            >
              Contact
            </Link>
          </div>
        </div>
      </div>

      <div
        className={`sm:hidden transform transition-all duration-500 ${
          isOpen ? "max-h-56 opacity-100" : "max-h-0 opacity-0"
        } ${isScrolled ? "bg-black shadow-md" : "bg-gradient-to-r from-gray-900 to-black"}`}
      >
        <div className="px-2 pt-2 pb-3 space-y-1">
          <Link
            to="/"
            onClick={handleCloseMenu}
            className={`block no-underline text-xl text-gray-300 hover:bg-gray-900 hover:text-white px-3 py-2 rounded-md text-base font-medium ${isScrolled ? "text-white" : "text-white"}`}
          >
            Home
          </Link>
          <Link
            to="/about"
            onClick={handleCloseMenu}
            className={`block no-underline text-xl text-gray-300 hover:bg-gray-900 hover:text-white px-3 py-2 rounded-md text-base font-medium ${isScrolled ? "text-white" : "text-white"}`}
          >
            About
          </Link>
          <Link
              to="/services"
              onClick={handleCloseMenu}
              className={`block text-gray-300 text-xl no-underline hover:bg-gray-900 hover:text-white px-3 py-2 rounded-md text-sm font-medium ${
                isScrolled ? "text-white" : "text-white"
              }`}
            >
              Services
            </Link>
          <Link
            to="/contact"
            onClick={handleCloseMenu}
            className={`block no-underline text-xl text-gray-300 hover:bg-gray-900 hover:text-white px-3 py-2 rounded-md text-base font-medium ${isScrolled ? "text-white" : "text-white"}`}
          >
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
